import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  Alert,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
  FormFeedback,
} from "reactstrap";
import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import { LoadingSpinner } from "../../../components";
import { saveUserEntry } from "../../../api/User";
import * as actions from "../../../actions";
import { login } from "../../../api/Login";

class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userName: "",
      email: "",
      password: "",
      confirmPassword: "",
      isLoading: false,
      errorMessage: "",
      isEmailValid: null,
      userNameValid: null,
      passwordValid: null,
      confirmPasswordValid: null,
    };
  }

  handleGoogleSuccess = async (credentialResponse) => {
    const decoded = jwtDecode(credentialResponse.credential);

    if (decoded.email_verified) {
      this.setState({ isLoading: true, errorMessage: "" });

      let password = "sub-" + decoded.sub;
      let data = {
        userID: 0,
        userName: decoded.name,
        password: password,
        phNo: "",
        loginId: decoded.email,
        role: { label: "User", value: 3 },
        address: "",
        isActive: true,
        hasToCheckPwd: false,
        masterSim: null,
        epinMasterSim: { label: "Not Selected", value: 0 },
        beforeMS: null,
        beforeEpinMS: null,
        masterSimEpin: null,
        IsEload: "Station",
        creditLimit: 0,
        preCreditlimit: 0,
        creditBalance: 0,
        salePersonUserId: { label: "Not Selected", value: 0 },
        paidType: { label: "Prepaid", value: "prepaid" },
        isPrepaid: "",
        profile: "",
        profileToDelete: "",
      };

      // companyId 1 is default for production
      var res = await saveUserEntry(data, 1);
      const userInfo = { loginId: data.loginId, password: data.password };

      if (res.status || res.message === "This user is already existed") {
        let response = await login(userInfo, "");
        let user = response && response.data;
        if (response && response.status && user && user.isAuth) {
          user.loginMethod = "email";
          this.props.keepUser(user);
          this.setState({ isLoading: false });
          this.props.history.push({ pathname: "/home" });
        } else {
          this.setState({
            errorMessage: (response && response.message) || "Google sign-in failed",
            isLoading: false,
          });
        }
      } else {
        this.setState({
          isLoading: false,
          errorMessage: res.message,
        });
      }
    }
  };

  validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value, errorMessage: "" }, this.validateFields);
  };

  validateFields = () => {
    const { userName, password, confirmPassword, email } = this.state;
    const isValid = this.validateEmail(email);

    this.setState({
      userNameValid: userName === "" ? null : userName.length >= 3,
      isEmailValid: email === "" ? null : isValid,
      passwordValid: password === "" ? null : password.length >= 6,
      confirmPasswordValid:
        confirmPassword === "" ? null : confirmPassword === password,
    });
  };

  isFormValid = () => {
    const { userNameValid, isEmailValid, passwordValid, confirmPasswordValid } =
      this.state;
    return userNameValid && isEmailValid && passwordValid && confirmPasswordValid;
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    if (!this.isFormValid()) return;
    await this.handleCreateUser();
  };

  async handleCreateUser() {
    let { userName, email, password } = this.state;
    this.setState({ isLoading: true, errorMessage: "" });

    let data = {
      userID: 0,
      userName: userName,
      password: password,
      phNo: "",
      loginId: email,
      role: { label: "User", value: 3 },
      address: "",
      isActive: true,
      hasToCheckPwd: true,
      checkPin: true,
      masterSim: null,
      epinMasterSim: { label: "Not Selected", value: 0 },
      beforeMS: null,
      beforeEpinMS: null,
      masterSimEpin: null,
      IsEload: "Station",
      creditLimit: 0,
      preCreditlimit: 0,
      creditBalance: 0,
      salePersonUserId: { label: "Not Selected", value: 0 },
      paidType: { label: "Prepaid", value: "prepaid" },
      isPrepaid: "",
      profile: "",
      profileToDelete: "",
    };

    // companyId 1 is default for production
    var res = await saveUserEntry(data, 1);
    if (res.status) {
      let response = await login({ loginId: email, password: password }, "");
      let user = response && response.data;
      if (response && response.status && user) {
        user.loginMethod = "email";
        this.props.keepUser(user);
        this.setState({ isLoading: false });
        this.props.history.push({ pathname: "/home" });
      } else {
        this.setState({
          isLoading: false,
          errorMessage: "Account created. Please login.",
        });
        this.props.history.push({ pathname: "/memberLogin" });
      }
    } else {
      this.setState({
        isLoading: false,
        errorMessage: res.message,
      });
    }
  }

  goToLogin = () => {
    this.props.history.push({ pathname: "/memberLogin" });
  };

  render() {
    const {
      userName,
      email,
      password,
      confirmPassword,
      errorMessage,
      isEmailValid,
      userNameValid,
      passwordValid,
      confirmPasswordValid,
      isLoading,
    } = this.state;

    return (
      <div className="app d-flex align-items-center justify-content-center min-vh-100">
        {isLoading && <LoadingSpinner />}
        <Container>
          <Row className="justify-content-center">
            <Col md="6" lg="5">
              <div className="text-center mb-4">
                <img
                  src={`${process.env.PUBLIC_URL}/SeaFarerInternetService_2.png`}
                  width="200"
                  height="auto"
                  alt="ESM"
                />
              </div>

              {errorMessage !== "" && <Alert color="danger">{errorMessage}</Alert>}

              <Card className="p-4">
                <CardBody>
                  <h2 className="mb-2 text-center">Register</h2>
                  <p className="text-muted text-center mb-4">Create your account</p>

                  <form onSubmit={this.handleSubmit}>
                    <InputGroup className="mb-3">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="fa fa-user"></i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        autoFocus
                        type="text"
                        id="userName"
                        name="userName"
                        value={userName}
                        onChange={this.handleChange}
                        placeholder="Username"
                        valid={userNameValid === true}
                        invalid={userNameValid === false}
                      />
                      <FormFeedback valid>Looks good!</FormFeedback>
                      <FormFeedback>Username must be at least 3 characters.</FormFeedback>
                    </InputGroup>

                    <InputGroup className="mb-3">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="fa fa-envelope-o"></i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        type="email"
                        id="email"
                        name="email"
                        value={email}
                        onChange={this.handleChange}
                        placeholder="Email Address"
                        valid={isEmailValid === true}
                        invalid={isEmailValid === false}
                      />
                      <FormFeedback valid>Looks good!</FormFeedback>
                      <FormFeedback>Please enter a valid email address.</FormFeedback>
                    </InputGroup>

                    <InputGroup className="mb-3">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="fa fa-lock fa-lg"></i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        type="password"
                        id="password"
                        name="password"
                        value={password}
                        onChange={this.handleChange}
                        placeholder="Password"
                        valid={passwordValid === true}
                        invalid={passwordValid === false}
                      />
                      <FormFeedback valid>Looks good!</FormFeedback>
                      <FormFeedback>Password must be at least 6 characters.</FormFeedback>
                    </InputGroup>

                    <InputGroup className="mb-3">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="fa fa-lock fa-lg"></i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        type="password"
                        id="confirmPassword"
                        name="confirmPassword"
                        value={confirmPassword}
                        onChange={this.handleChange}
                        placeholder="Confirm Password"
                        valid={confirmPasswordValid === true}
                        invalid={confirmPasswordValid === false}
                      />
                      <FormFeedback valid>Passwords match!</FormFeedback>
                      <FormFeedback>Passwords do not match.</FormFeedback>
                    </InputGroup>

                    <Button
                      color="primary"
                      block
                      type="submit"
                      className="mb-3"
                      disabled={!this.isFormValid()}
                    >
                      Create Account
                    </Button>
                  </form>

                  <div className="text-center mb-3" style={{ color: "#999" }}>
                    — or —
                  </div>

                  <div className="google-btn-wrapper text-center mb-3">
                    <GoogleLogin
                      shape="pill"
                      onSuccess={this.handleGoogleSuccess}
                      onError={() => {
                        console.log("Google Sign-In failed");
                      }}
                      auto_select={true}
                    />
                  </div>

                  <div className="text-center">
                    <span style={{ color: "#777" }}>Already have an account? </span>
                    <Button color="link" className="px-0" onClick={this.goToLogin}>
                      Login
                    </Button>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { auth: state.auth };
}

export default connect(mapStateToProps, actions)(withRouter(Register));